import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Errors from '../../components/Custom/Errors'

import { useProviderFileUrl } from '../../modules/hooks/dynamicUrlGenerator.js'

/*
 * The QuoteSearchHeadingFilters disclaimer section.
 */
const QuoteSearchHeadingFiltersDisclaimer = props => {
  const { orgTaxID } = props

  const { supplierHability, supplierPrioritized } = useSelector(state => state.quoteSearchHeadingFilters)

  return (
    <>
      <Errors errors={supplierHability?.error} providerFileUrl={useProviderFileUrl(orgTaxID)} />
      <Errors errors={supplierPrioritized?.errors} severity="primary" />
    </>
  )
}

QuoteSearchHeadingFiltersDisclaimer.propTypes = {
  orgTaxID: PropTypes.string.isRequired
}

export default QuoteSearchHeadingFiltersDisclaimer
